module.exports = __webpack_public_path__ + "img/a3c4ade.png";